export default __webpack_public_path__ + "static/media/image.28577f2e.png";